import {find} from 'lodash'
import {useIntl} from 'react-intl'
import {A1_CONSTANTS} from '../../core/constants'
import {useMemo} from 'react'
import clsx from 'clsx'

export const StatusViewOnly = ({status}: {status: string}) => {
  const intl = useIntl()

  const foundRelease =
    find(Object.values(A1_CONSTANTS.OPTIONS_RELEASE_STATUS), {
      value: status,
    }) || null

  const isHoldOrRejected = useMemo(() => {
    if (!foundRelease?.value) return false
    return [
      A1_CONSTANTS.OPTIONS_RELEASE_STATUS.HOLD.value,
      A1_CONSTANTS.OPTIONS_RELEASE_STATUS.REJECTED.value,
    ].includes(foundRelease?.value)
  }, [foundRelease?.value])

  return (
    <div className='d-flex justify-content-center align-items-center text-dark min-w-150px'>
      <span
        className={clsx('px-3 py-1 rounded-3', {
          'bg-light-danger': isHoldOrRejected,
        })}
      >
        {foundRelease ? intl.formatMessage({id: foundRelease?.label}) : ''}
      </span>
    </div>
  )
}
